import { useEffect } from 'react'
import { trackExperimentViewed } from '@mc/track-event'
import { CERTS_QUIZ_PLANS_FLAG } from '../constants'

export const useTrackPrcng1138Experiment = () => {
  useEffect(() => {
    trackExperimentViewed(CERTS_QUIZ_PLANS_FLAG)
  }, [])
}
